import React, { MouseEventHandler, useCallback, useEffect, useState } from 'react';
import { Button } from '@shared/UI';
import classNames from 'classnames';
import { useSteps } from '../../lib';
import './StepsFooter.scss';

interface StepsFooterProps {
    className?: string;
    submitLabel?: string;
    footerVisible?: boolean;
    nextLabel: string;
    previousLabel: string;
}

export const StepsFooter: React.FC<StepsFooterProps> = (props) => {
    const { className, submitLabel, footerVisible = true, nextLabel, previousLabel } = props;

    const { steps, stepNumber, setStepNumber, submitLoading, onSubmit, allowedSteps } = useSteps();

    const [nextDisabled, setNextDisabled] = useState<boolean>(false);
    const [prevDisabled, setPrevDisabled] = useState<boolean>(false);

    const buttonClick = useCallback<(direction: -1 | 1) => MouseEventHandler>(
        (direction) => () => {
            setStepNumber((prev) => prev + direction);
        },
        [setStepNumber],
    );

    useEffect(() => {
        setNextDisabled(allowedSteps.find((sn) => sn === stepNumber + 1) === undefined);
        setPrevDisabled(allowedSteps.find((sn) => sn === stepNumber - 1) === undefined);
    }, [stepNumber, allowedSteps]);

    return (
        <div
            className={classNames('feature-steps-footer', className, {
                none: !footerVisible,
            })}
        >
            {steps.length > 1 && (
                <Button
                    className={classNames('secondary', 'feature-steps-footer__button', {
                        none: stepNumber === 0,
                    })}
                    onClick={buttonClick(-1)}
                    disabled={prevDisabled}
                >
                    {previousLabel}
                </Button>
            )}
            <Button
                className={classNames('feature-steps-footer__button', 'primary', {
                    none: stepNumber < steps.length - 1,
                })}
                onClick={onSubmit}
                loading={submitLoading}
            >
                {submitLabel || 'Submit'}
            </Button>
            {steps.length > 1 && (
                <Button
                    className={classNames('feature-steps-footer__button', 'primary', {
                        none: stepNumber === steps.length - 1,
                    })}
                    onClick={buttonClick(1)}
                    disabled={nextDisabled}
                >
                    {nextLabel}
                </Button>
            )}
        </div>
    );
};
